// extracted by mini-css-extract-plugin
export default {"modal":"NewAddress_modal__-sjNq","checkBox":"NewAddress_checkBox__nbUhP"};